module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Some years since—it was during the winter before the Zulu War—a White Man was travelling through Natal. His name does not matter, for he plays no part in this story. With him were two wagons laden with goods, which he was transporting to Pretoria. The weather was cold and there was little or no grass for the oxen, which made the journey difficult; but he had been tempted to it by the high rates of transport that prevailed at that season of the year, which would remunerate him for any probably loss he might suffer in cattle. So he pushed along on his journey, and all went well until he had passed the little town of Stanger, once the site of Duguza, the kraal of Chaka, the first Zulu king and the uncle of Cetywayo. The night after he left Stanger the air turned bitterly cold, heavy grey clouds filled the sky, and hid the light of the stars.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Now if I were not in Natal, I should say that there was a heavy fall of snow coming,” said the White Man to himself. “I have often seen the sky look like that in Scotland before snow.” Then he reflected that there had been no deep snow in Natal for years, and, having drunk a “tot” of squareface and smoked his pipe, he went to bed beneath the after-tent of his larger wagon.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("During the night he was awakened by a sense of bitter cold and the low moaning of the oxen that were tied to the trek-tow, every ox in its place. He thrust his head through the curtain of the tent and looked out. The earth was white with snow, and the air was full of it, swept along by a cutting wind.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now he sprang up, huddling on his clothes and as he did so calling to the Kaffirs who slept beneath the wagons. Presently they awoke from the stupor which already was beginning to overcome them, and crept out, shivering with cold and wrapped from head to foot in blankets.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Quick! you boys,” he said to them in Zulu; “quick! Would you see the cattle die of the snow and wind? Loose the oxen from the trek-tows and drive them in between the wagons; they will give them some shelter.” And lighting a lantern he sprang out into the snow.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("At last it was done—no easy task, for the numbed hands of the Kaffirs could scarcely loosen the frozen reins. The wagons were outspanned side by side with a space between them, and into this space the mob of thirty-six oxen was driven and there secured by reims tied crosswise from the front and hind wheels of the wagons. Then the White Man crept back to his bed, and the shivering natives, fortified with gin, or squareface, as it is called locally, took refuge on the second wagon, drawing a tent-sail over them.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("For awhile there was silence, save for the moaning of the huddled and restless cattle.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“If the snow goes on I shall lose my oxen,” he said to himself; “they can never bear this cold.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Hardly had the words passed his lips when the wagon shook; there was a sound of breaking reims and trampling hoofs. Once more he looked out. The oxen had “skrecked” in a mob. There they were, running away into the night and the snow, seeking to find shelter from the cold. In a minute they had vanished utterly. There was nothing to be done, except wait for the morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("At last it came, revealing a landscape blind with snow. Such search as could be made told them nothing. The oxen had gone, and their spoor was obliterated by the fresh-fallen flakes. The White Man called a council of his Kaffir servants. “What was to be done?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("One said this thing, one that, but all agreed that they must wait to act until the snow melted.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Or till we freeze, you whose mothers were fools!” said the White Man, who was in the worst of tempers, for had he not lost four hundred pounds’ worth of oxen?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then a Zulu spoke, who hitherto had remained silent. He was the driver of the first wagon.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“My father,” he said to the White Man, “this is my word. The oxen are lost in the snow. No man knows whither they have gone, or whether they live or are now but hides and bones. Yet at the kraal yonder,” and he pointed to some huts about two miles away on the hillside, “lives a witch doctor named Zweete. He is old—very old—but he has wisdom, and he can tell you where the oxen are if any man may, my father.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Stuff!” answered the White Man. “Still, as the kraal cannot be colder than this wagon, we will go and ask Zweete. Bring a bottle of squareface and some snuff with you for presents.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("An hour later he stood in the hut of Zweete. Before him was a very ancient man, a mere bag of bones, with sightless eyes, and one hand—his left—white and shrivelled.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“What do you seek of Zweete, my white father?” asked the old man in a thin voice. “You do not believe in me and my wisdom; why should I help you? Yet I will do it, though it is against your law, and you do wrong to ask me,—yes, to show you that there is truth in us Zulu doctors, I will help you. My father, I know what you seek. You seek to know where your oxen have run for shelter from the cold! Is it not so?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“It is so, Doctor,” answered the White Man. “You have long ears.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, my white father, I have long ears, though they say that I grow deaf. I have keen eyes also, and yet I cannot see your face. Let me hearken! Let me look!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("For awhile he was silent, rocking himself to and fro, then he spoke: “You have a farm, White Man, down near Pine Town, is it not? Ah! I thought so—and an hour’s ride from your farm lives a Boer with four fingers only on his right hand. There is a kloof on the Boer’s farm where mimosa-trees grow. There, in the kloof, you shall find your oxen—yes, five days’ journey from here you will find them all. I say all, my father, except three only—the big black Africander ox, the little red Zulu ox with one horn, and the speckled ox. You shall not find these, for they have died in the snow. Send, and you will find the others. No, no! I ask no fee! I do not work wonders for reward. Why should I? I am rich.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now the White Man scoffed. But in the end, so great is the power of superstition, he sent. And here it may be stated that on the eleventh day of his sojourn at the kraal of Zweete, those whom he sent returned with the oxen, except the three only. After that he scoffed no more. Those eleven days he spent in a hut of the old man’s kraal, and every afternoon he came and talked with him, sitting far into the night.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("On the third day he asked Zweete how it was that his left hand was white and shrivelled, and who were Umslopogaas and Nada, of whom he had let fall some words. Then the old man told him the tale that is set out here. Day by day he told some of it till it was finished. It is not all written in these pages, for portions may have been forgotten, or put aside as irrelevant. Neither has it been possible for the writer of it to render the full force of the Zulu idiom nor to convey a picture of the teller. For, in truth, he acted rather than told his story. Was the death of a warrior in question, he stabbed with his stick, showing how the blow fell and where; did the story grow sorrowful, he groaned, or even wept. Moreover, he had many voices, one for each of the actors in his tale. This man, ancient and withered, seemed to live again in the far past. It was the past that spoke to his listener, telling of deeds long forgotten, of deeds that are no more known.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Yet as he best may, the White Man has set down the substance of the story of Zweete in the spirit in which Zweete told it. And because the history of Nada the Lily and of those with whom her life was intertwined moved him strangely, and in many ways, he has done more, he has printed it that others may judge of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("And now his part is played. Let him who was named Zweete, but who had another name, take up the story.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6209fe18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled638.vue
// module id = 72
// module chunks = 0